const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Platform instrument registry (no TradeStation Direct required).
 */

export async function searchPlatformInstruments(request, text, { limit = 20, assetClass } = {}) {
  if (!text || !String(text).trim()) return [];
  const params = new URLSearchParams({ q: String(text).trim(), limit: String(limit) });
  if (assetClass) params.set('assetClass', assetClass);
  const url = `${BACKEND_URL}/platform/instruments/search?${params}`;
  const data = await request(url, {}, 'GET');
  return Array.isArray(data) ? data : [];
}

export async function resolvePlatformInstrument(request, symbol, assetType) {
  if (!symbol) return null;
  const params = new URLSearchParams();
  if (assetType) params.set('assetType', assetType);
  const qs = params.toString();
  const url = `${BACKEND_URL}/platform/instruments/resolve/${encodeURIComponent(symbol)}${qs ? `?${qs}` : ''}`;
  try {
    return await request(url, {}, 'GET');
  } catch (_) {
    return null;
  }
}

/** TradeStation-shaped { Symbols, Errors } for drop-in use in ticker validation */
export async function fetchPlatformTickerDetails(request, symbol, assetType) {
  if (!symbol) return { Symbols: [], Errors: [{ Message: 'Symbol required' }] };
  const params = new URLSearchParams();
  if (assetType) params.set('assetType', assetType);
  const qs = params.toString();
  const url = `${BACKEND_URL}/platform/instruments/details/${encodeURIComponent(symbol)}${qs ? `?${qs}` : ''}`;
  const data = await request(url, {}, 'GET');
  if (data && Array.isArray(data.Symbols)) return data;
  return { Symbols: [], Errors: data?.Errors || [{ Message: 'Not found' }] };
}
